import { render, staticRenderFns } from "./personAttMan.vue?vue&type=template&id=b1c08b98&scoped=true&"
import script from "./personAttMan.vue?vue&type=script&lang=js&"
export * from "./personAttMan.vue?vue&type=script&lang=js&"
import style0 from "./personAttMan.vue?vue&type=style&index=0&id=b1c08b98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c08b98",
  null
  
)

export default component.exports